const PINCODE_REGEX = {
  IN: /^\d{6}$/, // India
  KE: /^\d{5}$/, // Kenya
  MY: /^\d{5}$/, // Malaysia
};

export const validatePincode = (
  pin,
  countryCode = process.env.REACT_APP_COUNTRYCODE,
) => {
  return PINCODE_REGEX[countryCode]?.test(pin) ?? false;
};

const PHONE_REGEX = {
  IN: /^\d{10}$/, // India
  MY: /^\d{10,11}$/, // Malaysia
  KE: /^\d{9,10}$/, // Kenya (without/with leading 0)
};

export const validatePhoneNumber = (
  number,
  countryCode = process.env.REACT_APP_COUNTRYCODE,
) => {
  console.log({
    number,
    countryCode,
    regex: PHONE_REGEX[countryCode],
    result: PHONE_REGEX[countryCode]?.test(String(number).trim()),
  });

  return PHONE_REGEX[countryCode]?.test(String(number).trim()) ?? false;
};
